import { connect } from 'react-redux';
import { UserDataOutput, State } from '../@types';
import { clearAuth } from '../redux/store/userData/user';

export type Props = {
  email: string;
  user: UserDataOutput | null | undefined;
  clearAuth: typeof clearAuth;
};

const mapState = ({
  userData: {
    user: { email, user },
  },
}: State) => ({
  email,
  user,
});

export default connect(mapState, { clearAuth });
